module.exports = "data:image/gif;base64,R0lGODdhQgAHALMAALmzsMC9uMnHxcnHxcnHxc/W2tbRzNnW0eTh3wAAAAAAAAAAAAAAAAAAAAAAAAAAACH5BAEAAAkALAAAAABCAAcAAARDMMkpQUGoCMp7spjmjZIQBBvpgVmqUqz4UkZgHOgMX60+xS4d0FfhyXxDYhJpDM6WwibxIyWaDDXnC/qsWk/arZcTAQA7"


/*****************
 ** WEBPACK FOOTER
 ** ./extjs/resources/themes/images/gray/slider/slider-v-bg.gif
 ** module id = 539
 ** module chunks = 0
 **/